import OtpVerification from "../../components/otpValidation/OtpVerification";
const Verify = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <OtpVerification onVerificationSuccess={() => {}} />
    </div>
  );
};

export default Verify;